// extracted by mini-css-extract-plugin
export var button = "_5s-7";
export var buttonRow = "_5s-6";
export var fadeIn = "_5s-1";
export var gradient = "_5s-0";
export var panel = "_5s-2";
export var panelIn = "_5s-3";
export var subtitle = "_5s-5";
export var title = "_5s-4";